import { Outlet } from "react-router-dom";
import { Preloader } from "@/components/layout/Preloader";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { CartDrawer } from "@/components/cart/CartDrawer";
import { CookieBanner } from "@/components/layout/CookieBanner";

export const PublicLayout = () => (
  <>
    <Preloader />
    <Header />
    <CartDrawer />
    <main className="overflow-x-clip">
      <Outlet />
    </main>
    <Footer />
    <CookieBanner />
  </>
);
